"use strict";

exports.__esModule = true;
exports.detectTestMode = void 0;

var _cookie = require("./cookie");

const detectTestMode = (urlKey = false, mhLogger = () => {}) => {
  if (!urlKey) {
    mhLogger('testmode', false);
  }

  const fetchCookie = (0, _cookie.getCookie)(urlKey);

  if (fetchCookie === '1') {
    mhLogger('testmode', true);
    return true;
  }

  mhLogger('testmode', false);
  return false;
};

exports.detectTestMode = detectTestMode;